import React from "react";
import { HomePage } from "../components/portfolio/HomePage";

export const Portfolio = () => {
  return <HomePage />;
};
